import { useEffect } from "react";
import { gql, useQuery } from "@apollo/client";
import moment from "moment";

import Loader from "@/components/common/Loader/Loader";
import PageHeader from "@/components/PageHeader";
import Seo from "@/components/seo";
import { useNowPlaying } from "@/components/contexts/now-playing";

function SongHistoryPage() {
  const { data, refetch } = useQuery(pageQuery, { fetchPolicy: "no-cache" });
  const { song } = useNowPlaying();

  useEffect(() => {
    refetch();
  }, [song, refetch]);

  if (!data) return <Loader />;

  return (
    <div className="container">
      <Seo title="History" />
      <PageHeader>Song History</PageHeader>
      <ul>
        {data && data.allHistory.edges.length ? (
          data.allHistory.edges.map(({ node }, i) => (
            <p key={i}>
              [{moment(node.timestamp).format("MMMM D, YYYY, h:mma")}]{" "}
              {node.song}
            </p>
          ))
        ) : (
          <p>There&apos;s nothing!</p>
        )}
      </ul>
    </div>
  );
}

export default SongHistoryPage;

const pageQuery = gql`
  query AllSongHistory {
    allHistory {
      edges {
        node {
          song
          timestamp
        }
      }
    }
  }
`;
